import BaseApi from './base.api'
import ApiUrls from './urls.api'

export default {

    PostLogin: function (dto) {
        return BaseApi.post(ApiUrls.Account.PostTokenLogin, dto);
    },

    PostResetPassword: function (resetPasswordDto) {
        return BaseApi.post(ApiUrls.Account.PostResetPassword, resetPasswordDto)
    },

    PostForgotPassword: function(email) {
        return BaseApi.post(`${ApiUrls.Account.PostForgotPassword}?email=${email}`)
    },

    GetInfo() {
        return BaseApi.get(ApiUrls.Account.GetInfo);
    }

}